import styled from "styled-components";
import DataTable from 'react-data-table-component';
import { grayColor } from "../../components/GlobalStyle"

export const EncabezadoContainer = styled.div`
display: grid;
gap: 2rem;
grid-auto-rows : 10rem;
grid-template-columns:repeat(auto-fit,minmax(11rem,1fr));
`;

export const UserContainer = styled.div`
display: flex;
position: absolute;
top: 3.5rem;
flex-direction: column;
width: 100%;
height: 100vh;
align-items: center;
`;

export const columnasContainer = styled.div`
display: flex;
flex-direction: row;
align-items: center;
`;

export const StyledTable = styled(DataTable)`
    width: 100%;
    height: auto;
`;

export const ProductoFiltroContainer = styled.div`
display: grid;
gap: 1rem;
grid-auto-rows : 5rem;
grid-template-columns:repeat(auto-fit,minmax(15rem,1fr));
`;

export const StyledFloatingButton = styled.div`
position: fixed;
width:60px;
height:60px;
bottom:40px;
right:40px;
`;
export const AyudaContainer = styled.div`
  position: relative;
  display: inline-block;
  cursor: help;
`;

export const AyudaTooltip = styled.span`
  visibility: hidden;
  width: 200px;
  background-color: #f9f9f9;
  color: #333;
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  position: absolute;
  z-index: 1;
  top: -5px;
  left: 10%;
  ${AyudaContainer}:hover & {
    visibility: visible;
  }
`;

export const AyudaTexto = styled.span`
  ${AyudaContainer}:hover & {
    visibility: visible;
  }
`;




export const styles = (theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    cardCategory: {
        color: grayColor[2],
        margin: "0",
        fontSize: "12px",
        marginTop: "0",
        paddingTop: "5px",
        marginBottom: "0",
    },
    cardTitle: {
        color: grayColor[2],
        marginTop: "0px",
        minHeight: "auto",
        fontSize: "10px",
        fontWeight: "150",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: grayColor[1],
            fontWeight: "400",
            lineHeight: "1",
        },
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '25ch',
    },

    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0",
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF",
        },
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1",
        },
    },
});

//modal styles
export const stylesModal = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

